import Structure from "../../../structure/structure";

const EventHomePanel: React.FC = () => {

	return (
		<div className="panel-body">
			<Structure postRegisterModules />
		</div>
	);
};

export default EventHomePanel;
